import { render, staticRenderFns } from "./newPageMy.vue?vue&type=template&id=6d808c69&scoped=true"
import script from "./newPageMy.vue?vue&type=script&lang=js"
export * from "./newPageMy.vue?vue&type=script&lang=js"
import style0 from "./newPageMy.vue?vue&type=style&index=0&id=6d808c69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d808c69",
  null
  
)

export default component.exports